export class BrowserUtils {
	public static get IsIE(): boolean {
		var doc = (<any>document);
		var isIE = false || !!doc.documentMode;
		return isIE;
	}

	public static getOffset(): number {
		if (BrowserUtils.IsIE) {
			return document.documentElement.scrollTop;
		} else {
			return window.scrollY;
		}
	}
}